import { reactive } from "vue";

export const mailState = reactive({
  selectedThreadId: undefined,
});
